import { Spin } from 'antd'
import { Suspense } from 'react'
import { RouteObject } from 'react-router-dom'

import {
  Project,
  Contact,
  Join,
  Login,
  Places,
  AboutUs,
  Verify,
  ResetPassword,
  ResetPasswordConfirmation,
  ResetPasswordVerify,
  FAQ,
  News,
  PrivacyPolicy,
  CommunityGuidelines,
  CapacitorRedirect,
} from './lazyLoad'
import * as ROUTES from '../../constants/routes'
import { NotFound } from '../../views/notFound'
import { PublicLayout } from 'src/components/layout'

const LazyLoad = ({ children }: { children: React.ReactNode }) => (
  <Suspense fallback={<Spin size="large" fullscreen tip="Loading..." />}>{children}</Suspense>
)

export const pubicRoutes: RouteObject[] = [
  {
    path: ROUTES.LOGIN,
    element: (
      <LazyLoad>
        <Login />
      </LazyLoad>
    ),
  },
  {
    path: ROUTES.JOIN,
    element: (
      <LazyLoad>
        <Join />
      </LazyLoad>
    ),
  },
  {
    path: ROUTES.HOME,
    Component: PublicLayout,
    children: [
      {
        path: ROUTES.HOME,
        element: (
          <LazyLoad>
            <CapacitorRedirect />
          </LazyLoad>
        ),
      },
      {
        path: ROUTES.ABOUT_US,
        element: (
          <LazyLoad>
            <AboutUs />
          </LazyLoad>
        ),
      },
      {
        path: ROUTES.EXPLORE,
        element: (
          <LazyLoad>
            <Places />
          </LazyLoad>
        ),
      },
      {
        path: ROUTES.PROJECT,
        element: (
          <LazyLoad>
            <Project />
          </LazyLoad>
        ),
      },
      {
        path: ROUTES.CONTACT,
        element: (
          <LazyLoad>
            <Contact />
          </LazyLoad>
        ),
      },
      {
        path: ROUTES.FAQ,
        element: (
          <LazyLoad>
            <FAQ />
          </LazyLoad>
        ),
      },
      {
        path: ROUTES.NEWS,
        element: (
          <LazyLoad>
            <News />
          </LazyLoad>
        ),
      },
      {
        path: ROUTES.PRIVACY_POLICY,
        element: (
          <LazyLoad>
            <PrivacyPolicy />
          </LazyLoad>
        ),
      },
      {
        path: ROUTES.COMMUNITY_GUIDELINES,
        element: (
          <LazyLoad>
            <CommunityGuidelines />
          </LazyLoad>
        ),
      },
      {
        path: ROUTES.VERIFY_TOKEN,
        element: (
          <LazyLoad>
            <Verify />
          </LazyLoad>
        ),
      },
      {
        path: ROUTES.RESET_PASSWORD,
        element: (
          <LazyLoad>
            <ResetPassword />
          </LazyLoad>
        ),
      },
      {
        path: ROUTES.RESET_PASSWORD_CONFIRMATION,
        element: (
          <LazyLoad>
            <ResetPasswordConfirmation />
          </LazyLoad>
        ),
      },
      {
        path: ROUTES.RESET_PASSWORD_VERIFY,
        element: (
          <LazyLoad>
            <ResetPasswordVerify />
          </LazyLoad>
        ),
      },
      { path: '*', Component: NotFound },
    ],
  },
]
